import { createContext } from 'react'
import { GlobalContextI, SectionsContextI } from './types'

export const GlobalContext = createContext<GlobalContextI>({} as GlobalContextI)

export const SectionsContext = createContext<SectionsContextI>({
  sections: [],
})
